import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_42: DocMigration = {
  maxSchemaVersion: "0.0.42",
  apply(json: any) {
    const facades = json.facades;
    if (facades) {
      for (const facadeKey in facades) {
        const facade = facades[facadeKey];
        if (facade?.sweepStrata) {
          for (const trimKey in facade.sweepStrata) {
            const trim = facade.sweepStrata[trimKey];
            const { sweep } = trim;

            sweep["elevationNote"] = sweep["elevationNoteOverride"];
            delete sweep["elevationNoteOverride"];

            sweep["bomDescription"] = sweep["bomDescriptionOverride"];
            delete sweep["bomDescriptionOverride"];
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_42;
